// frontend/src/pages/StudentNewLearningEntry.js
import React, { useState, useEffect } from 'react';
import './studenttopiccontent.css';
import StudentChapterTopics from './StudentChapterTopics';
import { API_BASE } from '../services/api.js';

const StudentNewLearningEntry = () => {
    const [subjects, setSubjects] = useState([]);
    const [chapters, setChapters] = useState([]);
    const [selectedSubject, setSelectedSubject] = useState(null);
    const [selectedChapter, setSelectedChapter] = useState(null);
    const [language, setLanguage] = useState('en');
    const [error, setError] = useState(null);

    useEffect(() => {
        const userData = localStorage.getItem('userData');
        const student = userData ? JSON.parse(userData).student : null;
        const accessibleSubjectIds = (student?.accessible_subjects || [])
            .filter(s => s.features?.includes('teaching_mode'))
            .map(s => s.subject_id);

        fetch(`${API_BASE}/subjects/`)
            .then(r => r.json())
            .then(data => setSubjects(data.filter(s => accessibleSubjectIds.includes(s.subject_id))))
            .catch(() => setError('Failed to load subjects'));
    }, []);

    const selectSubject = (subject) => {
        setSelectedSubject(subject);
        fetch(`${API_BASE}/chapters/?subject_id=${subject.subject_id}`)
            .then(r => r.json())
            .then(setChapters)
            .catch(() => setError('Failed to load chapters'));
    };

    if (selectedChapter) {
        return (
            <StudentChapterTopics
                chapterId={selectedChapter.chapter_id}
                chapterName={selectedChapter.name}
                language={language}
                onBack={() => setSelectedChapter(null)}
            />
        );
    }

    return (
        <div className="stc-container">
            <div className="stc-header">
                {selectedSubject && (
                    <button className="stc-back-btn" onClick={() => setSelectedSubject(null)}>&larr;</button>
                )}
                <h2>{selectedSubject ? selectedSubject.name : 'Choose a Subject'}</h2>
            </div>

            <div className="stc-language-toggle">
                <button className={language === 'en' ? 'active' : ''} onClick={() => setLanguage('en')}>English</button>
                <button className={language === 'hi' ? 'active' : ''} onClick={() => setLanguage('hi')}>हिंदी</button>
            </div>

            {error && <div className="stc-error">{error}</div>}

            {!selectedSubject && (
                <div className="stc-card-list">
                    {subjects.map(subject => (
                        <div key={subject.subject_id} className="stc-card" onClick={() => selectSubject(subject)}>
                            <div className="stc-card-body">
                                <h4>{subject.name}</h4>
                            </div>
                        </div>
                    ))}
                    {subjects.length === 0 && <p className="stc-empty">No subjects available yet.</p>}
                </div>
            )}

            {selectedSubject && (
                <div className="stc-card-list">
                    {chapters.map(chapter => (
                        <div key={chapter.chapter_id} className="stc-card" onClick={() => setSelectedChapter(chapter)}>
                            <div className="stc-card-body">
                                <h4>{chapter.name}</h4>
                            </div>
                        </div>
                    ))}
                    {chapters.length === 0 && <p className="stc-empty">No chapters available yet.</p>}
                </div>
            )}
        </div>
    );
};

export default StudentNewLearningEntry;